import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Mediator } from '@spotahome/soyuz-mediator';

import { Button } from '@spotahome/ui-library';
import { DSIcon } from '@spotahome/ui-library/base';
import { trans } from '@spotahome/soyuz/client';

import { TOGGLE_MAP } from '../common/utils/channels';

import './MapButton.scss';

const MapButton = ({ className = '', showMap, toggleShowMap }) => {
  const handleClickMap = () => {
    Mediator.publish(TOGGLE_MAP);
    toggleShowMap(!showMap);
  };

  const containerClassNames = classNames('map-button', className);

  const overlayClasses = classNames('map-button__overlay', {
    'map-button__overlay--active': showMap
  });

  return (
    <div className={containerClassNames}>
      <div className={overlayClasses}>
        <Button
          color="secondary"
          onClick={handleClickMap}
          renderIcon={() => (
            <DSIcon name={showMap ? 'grid_view' : 'location_on-1'} />
          )}
          renderContent={() =>
            trans(showMap ? 'seo.landing.show-list' : 'seo.landing.show-map')
          }
        />
      </div>
    </div>
  );
};

MapButton.propTypes = {
  className: PropTypes.string,
  toggleShowMap: PropTypes.func.isRequired,
  showMap: PropTypes.bool.isRequired
};

export default MapButton;
